import React from 'react';
import T from 'prop-types';
import { LocalNavigation } from '@acast/decibel';
import { ThLightGlyph } from '@acast/decibel-glyphs';
import navigateTo from '../../../shared/helpers/navigate-to';

export default function OverviewItem({ selected = undefined }) {
  return (
    <LocalNavigation.Item glyph={ThLightGlyph} onClick={() => navigateTo('/')} selected={selected}>
      Overview
    </LocalNavigation.Item>
  );
}

OverviewItem.propTypes = {
  selected: T.bool,
};

OverviewItem.defaultProps = {
  selected: undefined,
};
